import { render } from "./DescriptionComponent.vue?vue&type=template&id=7011c9be&scoped=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=7011c9be&lang=css"
import "./DescriptionComponent.vue?vue&type=style&index=1&id=7011c9be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7011c9be"]])

export default __exports__